/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
/**
 * Shared mixin for all wizard field components.
 * Provides common props, computed helpers, and the emit pattern.
 */
export default {
    props: {
        attribute: { type: Object, required: true },
        value: { default: null },
        locale: { type: String, default: 'fr' },
        error: { type: String, default: null },
        // Backoffice/operator context — enables the "Requis (backoffice)" flag.
        isBackoffice: { type: Boolean, default: false }
    },
    computed: {
        label() {
            // Backend resolves locale directly on attribute
            if (this.attribute.label) return this.attribute.label
            const t = this.getTranslation()
            return t.label || ''
        },
        instruction() {
            if (this.attribute.instruction) return this.attribute.instruction
            const t = this.getTranslation()
            return t.instruction || ''
        },
        help() {
            if (this.attribute.help) return this.attribute.help
            const t = this.getTranslation()
            return t.help || ''
        },
        description() {
            if (this.attribute.description) return this.attribute.description
            const t = this.getTranslation()
            return t.description || ''
        },
        isRequired() {
            return !!(this.attribute.requiredPublic || this.attribute.requiredForWizard
                || (this.isBackoffice && this.attribute.requiredBackoffice))
        }
    },
    methods: {
        getTranslation() {
            if (!this.attribute.translations) return {}
            if (Array.isArray(this.attribute.translations)) {
                return this.attribute.translations.find((t) => t.locale === this.locale) || {}
            }
            return this.attribute.translations[this.locale] || {}
        },
        emitValue(val) {
            this.$emit('input', val)
        }
    }
}
